<section class="environment-container" *ngIf="environment?.build.branch">
	<ul>
		<li><strong>Branch: </strong> {{ environment.build.branch }}</li>
		<li><strong>Commit Hash: </strong> {{ environment.build.commitHash }}</li>
		<li><strong>Build Number: </strong> {{ environment.build.number }}</li>
		<li><strong>Build Time: </strong> {{ environment.build.time }} ET</li>
	</ul>
</section>
